$mapDelete